export const abi = [
  {
    inputs: [
      {
        internalType: 'bytes32',
        type: 'bytes32'
      }
    ],
    name: 'getAlternativeSignature',
    outputs: [
      {
        internalType: 'string',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
] as const
